import React from "react";

export default function CheckIcon(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.774" height="16.834">
			<path
				d="M12.243 0H1.53A1.528 1.528 0 0 0 .008 1.53L0 11.424a1.535 1.535 0 0 0 .673 1.27l6.213 4.14 6.206-4.14a1.535 1.535 0 0 0 .673-1.27l.008-9.894A1.535 1.535 0 0 0 12.243 0ZM5.356 11.478 1.53 7.652l1.079-1.079 2.747 2.739L11.164 3.5l1.079 1.087Z"
				fill="#db6048"
			/>
		</svg>
	);
}

export function CheckLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="36.514" height="27.801">
			<path d="M11.618 21.992 2.9 13.278l-2.9 2.9L11.618 27.8l24.9-24.9-2.9-2.9Z" fill="#d7a44d" />
		</svg>
	);
}
